import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/pricing'

export default withAuthUser()(Page.Pricing)
